'use strict';

var svaneTvis = svaneTvis || {};

svaneTvis.accordion = svaneTvis.accordion || new function () {
    this.init = function () {

        let accordionToggles = document.querySelectorAll('.js-accordion-toggle');
        let accordion = document.querySelectorAll('.accordion');

        for (let i = 0; i < accordionToggles.length; i++) {
            accordionToggles[i].addEventListener('click', function (e) {
                e.preventDefault();
                const element = e.target;
                accordionAnimate(element);
            });
        }

        // Open accordion via hash in url
        var location = window.location.hash;
        if (location.indexOf('#open') != -1) {
            var el = document.querySelector(location);
            if (el) {
                el.firstElementChild.scrollIntoView({
                    'behavior': 'smooth'
                });
                accordionAnimate(el.firstElementChild);
            }
        }

    };

    // polyfill for closest
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {

        Element.prototype.closest = function (s) {
            var el = this;
            if (!document.documentElement.contains(el)) {
                return null;
            }
            do {
                if (el.matches(s)) {
                    return el;
                }
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    function accordionAnimate(element) {
        var contentItem = element.closest(".js-accordion-toggle").nextElementSibling;
        contentItem.classList.toggle('accordion__item--active');
        element.classList.toggle('accordion__item-title--active');

        var elementContent = contentItem.querySelector('.js-accordion-content');

        if (elementContent != undefined) {
            let elementContentHeight = elementContent.offsetHeight;
            let newHeight;
            let heightAttr = contentItem.dataset.height;

            if (heightAttr === undefined) {
                newHeight = contentItem.offsetHeight + elementContentHeight;
                contentItem.dataset.height = contentItem.offsetHeight;
            } else {
                if (heightAttr < contentItem.offsetHeight) {
                    newHeight = heightAttr;
                } else {
                    newHeight = contentItem.offsetHeight + elementContentHeight;
                }
            }
            contentItem.style.height = newHeight + 'px';
        }
    }

}();
